<template>
    <div>
        <EditEvent :singleEvent="singleEvent" :selectedRoomTeam="selectedRoomTeam"
            v-if="currentIsAdmin == '1' && currentTeamIsActive == 1" :currentUserId="currentUserId"
            :currentIsAdmin="currentIsAdmin" :currentTeamIsActive="currentTeamIsActive"
            :editEventOption="editEventOption" />

        <div class="team-details-section-wrap">
            <div class="event-sec-top sec-top px-0 pt-1 py-2" style="border-bottom: 1px solid #cce6fd;">
                <div class="left-part">
                    <div class="content" v-if="
                        singleEvent.exactStartDate != '' &&
                        singleEvent.exactStartTime != '' &&
                        singleEvent.exactEndTime != ''
                    ">
                        <span v-if="singleEvent.exactStartDate == singleEvent.exactEndDate">
                            {{ singleEvent.exactStartDate }}
                        </span>
                        <span v-else>{{ singleEvent.exactStartDate.split(",")[0] }} to
                            {{ singleEvent.exactEndDate }}</span>
                        <span v-if="singleEvent.time_zone !== null">
                            ({{ singleEvent.time_zone.split(")").pop() }})
                        </span>
                    </div>
                    <h3 class="text-capitalize">
                        {{ singleEvent.eventName }}
                    </h3>
                    <p class="single-asso-type">
                        <span v-if="singleEvent.association">
                            {{ singleEvent.association }} -
                        </span>
                        {{ singleEvent.eventType }}
                    </p>
                    <router-link :to="`/my-team/events/${selectedRoomTeam.id}`">
                        {{ selectedRoomTeam.teamName }}
                    </router-link>
                </div>
                <div class="right-part">
                    <div class="d-flex flex-column align-items-end justify-content-end">
                        <SingleEventDetailPlay v-if="selectedRoomTeam.teamType == 'sports'"
                            :singleEvent="singleEvent" />
                        <div class="right-part-btns mt-2">
                            <div class="icon-btn" v-if="currentIsAdmin == '1' && currentTeamIsActive == 1"
                                @click="openEditEventOption" v-click-outside="onClickOutside">
                                <img src="../../assets/Svg/ellipse.svg" alt="" />
                                <div class="sub-setting-options edit-event-options" v-if="editEventOption">
                                    <ul class="d-block pb-0">
                                        <li @click.stop="callModal()" class="cursor-pointer">
                                            <img src="../../assets/Svg/team/team-options/edit-2.svg" alt="">
                                            <p>Edit Event</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="friends-options p-0 pt-3">
                <nav class="navbar-expand-lg">
                    <div class="navbar-nav mx-auto">
                        <ul class="mb-0 events-games-tabs">
                            <router-link class="nav-link pt-0 pb-1" exact
                                :to="{ name: 'SingleEventDetail', params: { eventId: singleEvent.id } }">
                                <span>Boxscores</span>
                            </router-link>
                            <router-link class="nav-link pt-0 pb-1" exact :to="{
                                name: 'SingleEventPlayerStatistics',
                                params: {
                                    eventId: singleEvent.id,
                                    teamId: selectedRoomTeam.id
                                }
                            }" v-if="selectedRoomTeam.teamType == 'sports'">
                                <span>Player Statistics</span>
                            </router-link>
                            <router-link class="nav-link pt-0 pb-1" exact :to="{
                                name: 'SingleEventTeamStatistics', params: {
                                    eventId: singleEvent.id,
                                    teamId: selectedRoomTeam.id
                                }
                            }" v-if="selectedRoomTeam.teamType == 'sports'">
                                <span>Team Statistics</span>
                            </router-link>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import SingleEventDetailPlay from "./SingleEventDetailPlay.vue";
import EditEvent from "../Teams/ChatRight/ChatEvents/EditEvent.vue";
export default {
    name: "EventDetailTop",
    components: {
        SingleEventDetailPlay,
        EditEvent
    },
    data() {
        return {
            editEventOption: false,
            currentTeamIsActive: 1,
        }
    },
    props: {
        singleEvent: {
            type: Object
        },
        selectedRoomTeam: {
            type: Object
        },
        currentUserId: {
            type: String,
        },
        currentIsAdmin: {
            type: String,
        },
    },
    methods: {
        callModal: function () {
            this.$root.$emit("openEditEvent");
        },
        openEditEventOption() {
            this.editEventOption = !this.editEventOption;
        },
        onClickOutside() {
            this.editEventOption = false;
        },
    }
}
</script>